import React, {Component, PropTypes} from 'react';
import SwitchControl from 'components/SwitchControl';
import classNames from 'classnames';
import AnimakitExpander from 'animakit-expander';

import './TogglePaneControl.scss';

class TogglePaneControl extends Component {

	static propTypes = {
		label: PropTypes.string,
		paneOpened: PropTypes.bool,
		onChange: PropTypes.func,
		duration: PropTypes.number,
	};

	static defaultProps = {
		paneOpened: false,
		duration: 200,
	};

	state = {
		paneOpened: this.props.paneOpened,
	};

	_togglePane = (event) => {

		var paneOpened = !this.state.paneOpened;

		this.setState({
			paneOpened: paneOpened,
		});

		if (this.props.onChange) {
			this.props.onChange(event, paneOpened);
		}
	};

	render() {
		return (
			<div className={classNames([
					"TogglePaneControl",
					this.props.className
				])}>
				<SwitchControl className="TogglePaneControl-toggle"
					label={this.props.label}
					size="l"
					onChange={this._togglePane}
					checked={this.props.paneOpened} />
				<AnimakitExpander duration={this.props.duration} expanded={this.state.paneOpened}>
					<div className='TogglePaneControl-body'>
						{this.props.children}
					</div>
				</AnimakitExpander>
			</div>
		);
	}

}

export default TogglePaneControl;



// WEBPACK FOOTER //
// ./client/components/TogglePaneControl/TogglePaneControl.js